import React from 'react';
const TabButton = ({ isActive, onClick, title }) => {
    return (React.createElement("button", { type: "button", className: `
        transition-all
        duration-100
        rounded-full
        py-2
        px-8
        ${isActive ? 'bg-blue-600 text-white' : ''}
        font-semibold
        text-lg
        leading-6
        text-center
      `, onClick: onClick }, title));
};
export default TabButton;
